module.exports = __webpack_public_path__ + "img/down-arrow-blue.1cc0124a.svg";